import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { FoldersItem } from '../../MemberBin/FolderStateDefinition';
import { selectFolderFeedback } from '../../MemberBins/selectors/foldersSelectors';
import { FolderFeedbackState } from '../FolderFeedbackStateDefinition';
import { sendFeedback } from '../actions/FolderFeedbackActions';
import FolderContentTabs from './FolderContentTabs';
import FolderFeedbackForm from './FolderFeedbackForm';
import FolderFeedbackHeading from './FolderFeedbackHeading';
import FolderFeedbackMessageFlash from './FolderFeedbackMessageFlash';

export interface FolderFeedbackPageProps {
  ownerName: string;
  folderName: string;
  folderItems: FoldersItem[];
  isSubmitting: boolean;
  message: { type: 'success' | 'error'; text: string };
  dispatch: ThunkDispatch<any, any, any>;
}

export const FolderFeedbackPage = ({
  ownerName,
  folderName,
  folderItems,
  isSubmitting,
  message,
  dispatch,
}: FolderFeedbackPageProps): ReactElement => {
  return (
    <div className="mt-5 mx-2 md:mx-24">
      <FolderFeedbackMessageFlash message={message} />
      <FolderFeedbackHeading folderName={folderName} ownerName={ownerName} />
      <FolderFeedbackForm
        onSubmit={(content) => dispatch(sendFeedback(content))}
        isSubmitting={isSubmitting}
      />
      <FolderContentTabs
        allowEmptyTabs={false}
        allowSelections={false}
        allowDownloads={false}
        folderItems={folderItems}
        removedStockItems={[]}
      />
    </div>
  );
};

const FolderFeedbackPageContainer = (): ReactElement => {
  const {
    ownerName,
    folderName,
    folderItems,
    isSubmitting,
    message,
  }: FolderFeedbackState = useSelector(selectFolderFeedback);
  const dispatch = useDispatch();

  return (
    <FolderFeedbackPage
      ownerName={ownerName}
      folderName={folderName}
      folderItems={folderItems}
      isSubmitting={isSubmitting}
      message={message}
      dispatch={dispatch}
    />
  );
};

export default FolderFeedbackPageContainer;
